/* ModuleHelp — botão "?" + Popover com explicação institucional do módulo.
 *
 * Uso:
 *   <ModuleHelp module="biblioteca" />
 *
 * Aparece ao lado do título do módulo. Abre um popover discreto com:
 *   - Resumo da função
 *   - Detalhes metodológicos
 *   - Lista de dicas (opcional)
 *   - Link para a página de Legendas do Sistema
 */
import { Link } from "react-router-dom";
import { HelpCircle, BookOpen } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { MODULE_HELP } from "@/lib/moduleHelp";

export default function ModuleHelp({ module, className = "" }) {
  const data = MODULE_HELP[module];
  if (!data) return null;
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          type="button"
          aria-label={`Ajuda: ${data.title}`}
          title={`Ajuda: ${data.title}`}
          data-testid={`module-help-${module}`}
          className={`inline-flex items-center justify-center w-8 h-8 rounded-full border border-slate-200 text-slate-500 hover:text-[#0F1B2D] hover:bg-slate-50 hover:border-slate-300 dark:hover:bg-slate-800 dark:hover:text-slate-200 transition focus:outline-none focus:ring-2 focus:ring-amber-400/40 ${className}`}
        >
          <HelpCircle size={16} />
        </button>
      </PopoverTrigger>
      <PopoverContent
        side="bottom"
        align="start"
        sideOffset={6}
        className="w-[340px] max-w-[90vw] p-4"
      >
        <div className="font-display font-semibold text-[15px] text-[#0F1B2D] dark:text-slate-100 mb-2">
          {data.title}
        </div>
        <p className="text-[13.5px] leading-relaxed text-slate-600 dark:text-slate-300">
          {data.summary}
        </p>
        {data.details && (
          <p className="text-[13px] leading-relaxed text-slate-500 dark:text-slate-400 mt-2.5">
            {data.details}
          </p>
        )}
        {Array.isArray(data.tips) && data.tips.length > 0 && (
          <ul className="mt-3 space-y-1 text-[12.5px] text-slate-600 dark:text-slate-300">
            {data.tips.map((t) => (
              <li key={t} className="flex gap-2 leading-snug">
                <span className="text-amber-500 mt-0.5">›</span>
                <span>{t}</span>
              </li>
            ))}
          </ul>
        )}
        <Link
          to="/legendas"
          className="mt-4 inline-flex items-center gap-1.5 text-[12.5px] text-amber-600 hover:text-amber-700 font-semibold"
          data-testid="module-help-glossario-link"
        >
          <BookOpen size={12} /> Legendas do Sistema
        </Link>
      </PopoverContent>
    </Popover>
  );
}
